module.exports = {"140502001":"东街街道","140502002":"西街街道","140502003":"南街街道","140502004":"北街街道","140502006":"钟家庄","140502007":"西上庄","140502009":"开发区街道","140502100":"北石店镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140502.json
// module id = 308
// module chunks = 0